import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

interface GuidedHighlightingParnassusPostPayload {
  student_id: string;
  student_grade_level: number;
  interaction_id: number;
  interaction_type: string;
  score: number;
  has_guided_highlighting: boolean;
  has_power_words: boolean;
}

const useGuidedHighlightingParnassusPost = () => {
  const createEventRecordRequest = useCallback(
    (payload: GuidedHighlightingParnassusPostPayload) => {
      const requestUrl = `${MONOLITH_ORIGIN}/parnassus/api/v2/challenges/progress`;

      return new Request(requestUrl, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      });
    },
    [],
  );

  return useRestMutation(createEventRecordRequest);
};

export default useGuidedHighlightingParnassusPost;
